"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Strip;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _throttle = _interopRequireDefault(require("lodash/throttle"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function Strip(_ref) {
  var children = _ref.children,
    _ref$stripWidth = _ref.stripWidth,
    stripWidth = _ref$stripWidth === void 0 ? 90 : _ref$stripWidth,
    moreComponent = _ref.moreComponent,
    moreComponentProps = _ref.moreComponentProps;
  var rootRef = (0, _react.useRef)();
  var itemsRef = (0, _react.useRef)([]);
  var _useState = (0, _react.useState)(-1),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    index = _useState2[0],
    setIndex = _useState2[1];
  var count = _react["default"].Children.count(children);
  var moreNumber = count - index;
  var nodes = _react["default"].Children.map(children, function (child, index) {
    return /*#__PURE__*/_react["default"].cloneElement(child, {
      ref: function ref(node) {
        return itemsRef.current[index] = node;
      }
    });
  });
  function checkWidth() {
    itemsRef.current = itemsRef.current.filter(Boolean);
    if (!rootRef.current) return;
    var width = rootRef.current.offsetWidth;
    var currWidth = 0;
    for (var i = 0; i < itemsRef.current.length; i++) {
      var element = itemsRef.current[i];
      var style = window.getComputedStyle(element, null);
      var itemOuterWidth = element.offsetWidth + Number.parseInt(style.getPropertyValue('margin-left')) + Number.parseInt(style.getPropertyValue('margin-right'));
      currWidth += itemOuterWidth;
      if (currWidth + stripWidth >= width) {
        setIndex(i);
        break;
      }
    }
  }
  (0, _react.useEffect)(function () {
    checkWidth();
  }, [children]);
  (0, _react.useEffect)(function () {
    var event;
    var debouncedCheckWidth = (0, _throttle["default"])(function () {
      setIndex(-1);
      checkWidth();
    }, 500);
    window.addEventListener('resize', event = debouncedCheckWidth);
    return function () {
      window.removeEventListener('resize', event);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    ref: rootRef,
    className: "w-full flex items-center flex-wrap"
  }, !!~index ? nodes.slice(0, index) : nodes, !!~index && nodes.length > index && (moreComponent ? ( /*#__PURE__*/_react["default"].createElement(moreComponent, _objectSpread(_objectSpread({}, moreComponentProps), {}, {
    index: index,
    number: moreNumber
  }))) : /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm font-semibold text-light inline-flex",
    style: {
      width: stripWidth
    }
  }, "+ ", moreNumber, " more")));
}
//# sourceMappingURL=Strip.js.map